import React from "react";

export default function OurAiServices() {
  return (
    <React.Fragment>
      <div className="row my-2 latestApiDevelopmentDiv px-6">
        <div className="col-12 text-center py-4">
          <h2>Our AI Services</h2>
        </div>
        <div className="col-md-4">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage1.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">AI Consultation and Strategy</h3>
            <p className="mb-0">
              A strategic roadmap can help you reach the potential of AI for
              your business. We collaborate with businesses to determine
              opportunities, pick the right technologies, and build a
              progressive AI integration plan that delivers a measurable return
              on investment.
            </p>
          </div>
        </div>
        <div className="col-md-4 mt-3 mt-md-0">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage2.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">AI App Development</h3>
            <p className="mb-0">
              We develop custom AI applications designed to solve your unique
              business challenges. Our development services focus on creating
              intelligent, scalable solutions from the ground zero to automate
              complex workflows and provide a competitive edge.
            </p>
          </div>
        </div>
        <div className="col-md-4 mt-3 mt-md-0">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage3.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">AI Agents</h3>
            <p className="mb-0">
              AI agents perform complex multi-step tasks autonomously without
              human interference. We get familiar with your specific business
              objectives to develop and train custom AI agents that adapt to
              your data across current systems.
            </p>
          </div>
        </div>
        <div className="col-md-4 mt-3">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage4.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">Virtual Assistants</h3>
            <p className="mb-0">
              Virtual assistants provide a flexible way for automating
              interactions between customers and employees. We analyze
              conversational data and train AI models to make sure it maintains
              your brand voice and provides accurate, relevant responses.
            </p>
          </div>
        </div>
        <div className="col-md-4 mt-3">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage5.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">AI Integration</h3>
            <p className="mb-0">
              Upgrade your existing systems with AI integration. We provide AI
              integration services that connect your existing software and
              platforms to new AI capabilities. We automate tasks and provide
              improved insights to deliver value to your technology stack.
            </p>
          </div>
        </div>
        <div className="col-md-4 mt-3">
          <div className="aiOurServiceCard p-3">
            <img
              src="/images/AiServicesImage6.png"
              alt="AI Consultation and Strategy"
            />
            <h3 className="mt-4">Generative AI Solutions</h3>
            <p className="mb-0">
              Generative AI revolutionizes content and creative workflows. We
              develop and implement technologies to instantly generate text,
              images, and code. This technology accelerates marketing campaigns,
              automates content creation, and prototypes new ideas.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
